import { ORGANIZATIONS_GET } from "../Actions/OrganizationList.action";
const defaultState = {
    organizations:[]
};  
export const organizationList = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
      case ORGANIZATIONS_GET:
        return {
            ...state,
            organizations: payload.organizations,
          };
      default:
        return state;
    }
  };
  